import axios from "axios";

export const loginApi = async (
  Username: string, 
  Password: string, 
  captchaId: string,
  answer: number
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/api/Auth/Login`,
      { Username, Password, captchaId, answer }
    );
    return response.data; 
  } catch (error: any) {
    console.error("Login failed", error);
    
    // Properly extract the error message from the API response
    if (error.response?.data?.message) {
      throw new Error(error.response.data.message);
    } else if (error.response?.data) {
      throw new Error(error.response.data);
    } else {
      throw new Error("Login failed. Please try again.");
    }
  }
};

export const statustimestamp = async (doctId:number)=>{
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}api/Marketing/statustimestamp`,{
        doctId,
        Event:"View Time Stamp TAT",
     
      }
    );
    return response.data; 
  } catch (error: any) {
    console.error("Login failed", error);
  }
};

export const fetchMenus = async () => {

  const roleName = sessionStorage.getItem("roleName");
  const isMarketingHead = roleName === "Marketing Head";

 
  const dashboardMenu = {
    menuId: 1,
    menuName: "Dashboard",
    displayText: "Dashboard",
    routePath: "/dashboard",
    componentKey: "dashboard",
    sortOrder: 1,
    permissions: { canView: true, canAccess: true },
    children: [],
  };

 
  const doctorsMenu = {
    menuId: 2,
    menuName: "Doctors",
    displayText: "Doctors",
    routePath: null,
    componentKey: "doctors",
    sortOrder: 2,
    permissions: { canView: true, canAccess: true },
    children: isMarketingHead
      ? [] 
      : [
          {
            menuId: 3,
            menuName: "Add New Doctor",
            displayText: "Add New Doctor",
            routePath: "/dashboard/new-doctor-profile",
            componentKey: "newDoctorProfile",
            sortOrder: 1,
            permissions: { canView: true, canAccess: true },
            children: [],
          },
        ],
  };

  return {
    menus: [dashboardMenu, doctorsMenu],
  };
};

